import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '/api/product-in-crafts',
    name: 'GET_PRODUCT_IN_CRAFT_LIST',
    manual: false,
  });

  return [data || [], exec, isRequestSuccessed];
});
